export default {
  common: {
    country: 'Country',
    city: 'City',
    currency: 'Currency',
    search: 'Search',
    reset: 'Reset',
    postCode: 'Postal Code',
    address: 'Address',
    id: 'ID',
    stockLocation: 'Stock Location',
    stockLocation2: 'Stock Location',
    action: 'Action',
    remove: 'Remove',
    plzInput: 'Please input the ',
    plzSelect: 'Please select the ',
    plzEnterSelect: 'Please enter and select the ',
    plzAdd: 'Please add ',
    cancel: 'Cancel',
    ok: 'OK',
    yes: 'Yes',
    no: 'No',
    fullFormTip: 'Please complete the information',
    submitSuccess: 'Submitted successfully',
    systemError: 'system error',
    successful: 'Successful',
    startMonth: 'Start month',
    endMonth: 'End month',
    expandAllConditions: 'Expand all conditions',
    putAway: 'Put away',
    month: '',
    week0: 'Mon.',
    week1: 'Tues.',
    week2: 'Wed.',
    week3: 'Thur.',
    week4: 'Fri.',
    week5: 'Sat.',
    week6: 'Sun.',
    add: 'Add',
    id2: 'ID',
    name: 'Name',
    status: 'Status',
    edit: 'Edit',
    open: 'Open',
    disable: 'Disable',
    email: 'Email',
    message: 'Message',
    submit: 'Submit',
    confirmDelete: 'Confirm delete?',
    save: 'Save',
    back: 'Back',
    day: 'Days',
    tooLong: 'too long',
    validateEmail: 'Please enter your vaild email',
  },
  crm: {
    domesticPayment:"Domestic payment",
    overseaPayment:"Oversea payment",
    phoneNumber:'phone number',
    payMethod:'payment method',
    defaultOption: 'Is it default',
    idNumber:'ID',
    provideRetailPrice:'provideRetailPrice',
    exportfields:'exportfields',
    saleArea:'saleArea',
    selectVendorStockType:'Please Select VendorStockType',
    selectSystemName:"Please Select SystemName",
    selectVendorGeography:"Please Select VendorGeography",
    selectVendorCurrency:"Please Select VendorCurrency",
    processingComplete:"Processing Complete",
    submit:'Submit',
    cancel:'Cancel',
    orderNotifyStatus:'orderNotifyStatus',
    portfields:'Import / export fields',
    orderFields:'Order Import / Export Fields',
    selectGeography:'Please select Geography',
    geography:'geography',
    selectSystem:"Please select System Name",
    vendorId: 'Vendor ID',
    storeCode: "Store Code",
    vendorName: 'Vendor Name',
    vendorAlias: 'Vendor alias',
    vendorStoreStatus: 'Vendor Store Status',
    vendorStartDate: 'Vendor Start Date',
    vendorInfoLastUpdateTime: 'Vendor Information Last Update Time',
    vendorType: 'Vendor Type',
    vendorRegion: 'Vendor Region',
    saleChannels: 'Sale Channels',
    vendorGeography: 'Vendor Geography',
    vendorLicenceLocation: 'Vendor\'s Business Licence Location',
    vendorCode: 'Vendor Code',
    systemName: 'System Name',
    stockConnectivityMethod: 'Stock Connectivity Method',
    productConnectivityMethod: 'Product Connectivity Method',
    pricingConnectivityMethod: 'Pricing Connectivity Method',
    imRepresentative: 'IM Representative',
    imAssistantRepresentative: 'IM Assistant Representative',
    preSaleAvailablity: 'Pre-sale Availablity',
    editStatus: 'Edit Status',
    basicInfo: 'Basic Info',
    payment: 'Payment',
    billingInfo: 'Billing Info',
    billingInfo2: 'Invoicing Info',
    vendorContacts: 'Vendor Contacts',
    needAudit: '(need audit)',
    otherSaleChannelInfo: 'Other Sale Channel Info',
    fulfillment: 'Fulfillment',
    vendorEventParticipation: 'Vendor Event Participation',
    imBusinessStatus: 'IM Business Status',
    vendorStockStatus: 'Vendor Stock Status',
    shipmentStockLocationInfo: 'Shipment & Stock Location Info',
    vendorInfo: 'Vendor Information',
    contractOrSLASigned: 'Contract or SLA Signed？',
    shippingMethods: 'Shipping Methods',
    vendorsShippingCountry: 'Vendor\'s Shipping Country',
    vat: 'VAT',
    vendorEvaluation: 'Vendor Evaluation',
    vendorsPartnership: 'Vendor\'s definition of the IM Partnership',
    salesSatisfaction: 'Sales Satisfaction',
    mpSalesSatisfaction: 'MP Sales Satisfaction',
    techInfo: 'Tech Info',
    paymentMethod: 'Payment Method',
    depositAmount: 'Deposit Amount',
    paymentTiming: 'Payment Timing/Frequency',
    settlementCycle: 'Settlement cycle',
    otherPaymentTiming: 'Please input the other Payment Timing/Frequency',
    paymentRemark: 'Other Payment Methods & Amount',
    vendorSettlementCurrency:'Store settlement currency configuration',
    pricingInfo: 'Pricing Info',
    retailPriceIncludesTax: 'Retail Price Includes Tax ?',
    vendorLoginAccount: 'Vendor Portal Login Account',
    supplyPriceIncludesTax: 'Supply Price Includes Tax？',
    provideHangingPrice: 'Whether to provide hanging price',
    ifIMCanGetTaxBack: 'If IM Can Get Tax Back？',
    companyName: 'Company Name',
    vatNumber: 'VAT Number',
    contactPerson: 'Contact Person',
    contactEmail: 'Contact Email',
    contactPhoneNumber: 'Contact Phone Number',
    payeeInfo: 'Payee Info',
    payeeName: 'Payee Name',
    bankName: 'Bank Name',
    bankAccount: 'Bank Account',
    swiftCode: 'Swift code',
    iban: 'IBAN',
    bankAddress: 'bank Address',
    mainContactName: 'Name',
    mainContactTitle: 'Title',
    mainContact: 'Contact Methods',
    mainContactReponseSpeed: 'Reponse Speed',
    mainContactResponsiblefor: 'Responsible for',
    mainContactNegotitationStyle: 'Negotitation Style',
    visitInfo: 'Visit Info',
    quarterlyF2FVisitFrequency: 'Quarterly F2F Visit Frequency',
    otherVisitingFrequency: 'Other Visiting Frequency',
    otherInfo: 'Other Info',
    mainContactIMOrderEmail: 'IntraMirror Order Email',
    retailStore: 'Retail Store',
    hasRetailStore: 'Has Retail Store',
    hasRetailStore1: 'Yes',
    hasRetailStore0: 'No/Unknown',
    retailStoreScale: 'Retail Store Scale',
    retailStoreName: 'Name',
    retailStoreAddress: 'Address',
    retailStoreYears: 'Years of Operatation',
    retailStoreAnnualSales: 'Annual Sales',
    retailStoreSalesContribution: 'Sales Contribution %',
    otherSalesChannels: 'Other Sales Channels',
    otherSalesChannels2: 'Other Sales Channels',
    ecWebsite: 'EC Website',
    hasEcWebsite: 'EC Website',
    wholesaleBusiness: 'Wholesale',
    hasWholesaleBusiness: 'Has Wholesale Business',
    farfetch: 'Farfetch',
    hasFarfetch: 'Has Farfetch',
    dewu: 'Poizon',
    hasDewu: 'Has Poizon',
    yearsOfOperatation: 'Years of Operatation',
    annualSales: 'Annual Sales',
    salesContribution: 'Sales Contribution %',
    sourceOfGoods: 'Stock Supply Sources',
    mpProfitExpectation: 'MP Profit % Expectation',
    profitExpectation: 'Profit % Expectation',
    stockLocationId: 'Stock Location ID',
    stockLocationName: 'Stock Location Name',
    shipFromStockLocation: 'Ship from Stock Location',
    stockValidPeriod: 'Stock Valid Period',
    fullClearPercentage: 'Percentage of Full Clearance',
    skuCodeAskeyCode: 'Only SKU Code Connectivity',
    isCo: 'CarryOver',
    switchOfFullClared: 'Full Stock Clearance Switch',
    fullGoods: 'Full goods quantity connection',
    fullStock: 'Full stock quantity connection',
    personalSellerIMID: 'Personal Seller IM ID',
    addPayeeInfo: 'Add',
    editPayeeInfo: 'Edit',
    vendorContactsInfo: 'Vendor Contacts Info',
    addVendorContact: 'Add Vendor Contact',
    editVendorContact: 'Edit Vendor Contact',
    formOfCommunication: 'Form of Communication',
    contactNumber: 'Contact number',
    addContactInfo: 'Add contact info',
    addRetailStore: 'Add Retail Store',
    rollingPreSale: 'Rolling pre-sale',
    supportPreSale: 'Yes',
    notSupportPreSale: 'No',
    auditStatus0: 'In the process of verification',
    auditStatus1: 'Application approved',
    auditStatus2: 'Application Dismissed',
    selectMainStore: 'Select the related main store',
    taxRefund: 'Yes',
    noTaxRefund: 'No',
    sureDelContact: 'Sure you want to delete this vendor contact information?',
    needAddedAfterDel: 'After deleting, you need to add it again',
    doYouContinue: ', do you want to continue',
    copyVendor: 'Copy',
    selectVendor: 'Select vendor',
    copyRelatedStoreInfo: 'Copy related store information',
    submitAudit: 'Submit Audit',
    saveAudit: 'Save & Audit',
    cancelEdit: 'cancel edit',
    effectiveAfterAudit: 'Effective after audit',
    infoCompletion: 'Information completion',
    requiredFieldCompletion: 'Required field completion',
    groupName: 'Group name',
    parentCompanyName: 'Parent company name',
    businessEntityName: 'Business entity name',
    passTheAudit: 'Pass the audit',
    dismiss: 'Dismiss',
    auditSubmitTip: 'Tip: After the review is passed, the modified content will take effect; after the rejection, the edited and modified content will not take effect, and you can resubmit the modification',
    auditPassTip: 'Modified content will take effect immediately',
    auditDismiss: 'Modifications after rejection will not take effect',
    auditPassTip2: 'Contents of application will take effect immediately',
    auditDismiss2: 'Contents of application after rejection will not take effect',
    auditPassConfirmTip: 'Are you sure the review is passed?',
    auditDismissConfirmTip: 'Are you sure to reject the application?',
    vendorCurrency: 'Vendor Currency',
    editAudit: 'Edit Audit',
    applicant: 'Applicant',
    applyTime: 'Application time',
    editcontent: 'Edit content',
    viewVendorInfo: 'View vendor info',
    editVendorInfo: 'Edit vendor info',
    reEdit: 'Re-edit',
    audit: 'Audit',
    respondSpeedForFulfillmentIssues: 'Respond Speed for Fulfillment issues',
    salesFulfillment: 'Sales Fulfillment',
    canceledOrders: 'Cancelled Orders',
    serviceScore: 'Service Score',
    mistakeAndDamagedOrders: 'Mistake and Damaged Orders',
    delayOrders: 'Delay Orders',
    avgServiceScoreArea: 'Average Service Score for the area',
    serviceScoreRankingArea: 'Service Score ranking in its area',
    serviceScoreTrendGraph: 'Service Score Trend Graph',
    last3Years: 'Last 3 Years',
    lastYear: 'Last Year',
    thisYear: 'This Year',
    allEvents: 'All events',
    participated: 'Participated',
    promotionDesc: 'Promotion Desc',
    promotionName: 'Promotion name',
    promotionTime: 'Promotion time',
    whetherParticipate: 'Whether to participate',
    createdList: 'Current vendors',
    creatingList: 'Pending new vendor',
    storeBuildStatus: 'Store build status',
    auditStore: 'Audit new vendor info',
    setTechInfo: 'Connection authorization setting',
    reApplyBuildStore: 'Re-edit',
    editTechInfo: 'Edit vendor tech info',
    startBusiness: 'Start Business Operations',
    suspensionBusiness: 'Suspension of business',
    updateStatusToPending: 'swith to pending',
    apiPermissionConf: 'API Permission Config',
    checkLogisticsConf: 'Check whether the logistics configuration is complete',
    currency: 'Currency',
    deadlineForDay: 'Order Deadline for a Day',
    confirmTimeFromMerchant: 'Order Confirmation Day from Merchant',
    shippingDeadline: 'Shipping Deadline',
    orderShippingDay: 'Order Shipping Day',
    operationType: 'Merchant Operation Type',
    notifyEmailSettings: 'Notification Email Setting',
    afterSaleNotifyEmail:'afterSaleNotifyEmail',
    workOrderAutoEmailSettings: 'Ticketing Email informing setting',
    workOrderAutoEmai:'workOrderAutoEmai',
    vendorOrderPushEmail: 'Main Contact\'s IntraMirror Order Email',
    using: 'Using',
    terminated: 'Terminated',
    enable: 'Using',
    shut: 'Terminated',
    orderPushTime: 'Email notification timing',
    pushEmailContent: 'Email Content',
    addPushEmail: 'Add Email',
    orderNotifyEmail: 'Order Notification Link',
    taxIncluded: 'Tax included',
    taxExcluded: 'Tax excluded',
    support: 'Support',
    notSupport: 'Not support',
    lookAgain: 'Look again',
    applyCreateStore: 'Apply to create a new store',
    contractTime: 'Contract time',
    registedCompanyName: 'Registed Company Name',
    registeredCompanyName: 'Registered Company Name',
    areaCode: 'area code',
    afterSaleNotifyEmailSetting: 'After-sale Notification Email setting',
    canInputEmailsMost: 'You can input 10 emails at most',
    orderEmailTime: 'Order Time',
    orderEmailTip: 'The orders which is created in the following time will be send to the email',
    orderEmailTip2: 'You can input 5 order time at most',
    timeZone: 'Time Zone',
    selectOrderTime: 'Select Order Time',
    emailFormatIncorrect: 'Email format is incorrect',
    addTime: 'Add Time',

    imBusinessStatusDesc: 'IM Business Status',
    currGmv: 'Year GMV（YTD）',
    mpGrossRate: 'MP % Gross Profitrate (YTD)',
    omsGrossGate: 'Wholesale % Gross Profitrate (YTD)',
    currSuborderQty: 'GMV Unit (YTD/Monthly)',
    mpGmvAddYear: 'MP GMV（YTD）',
    currGmvRank: 'GMV Ranking（YTD）',
    gmvIncreaseRateRank: 'GMV % Growth Ranking（YOY）',
    currSuborderQtyRank: 'Unit Sold  Ranking（YTD）',
    suborderQtyIncreaseRateRank: 'Unit Sold Growth Ranking（YOY）',
    wholesale1GmvAddYear: 'PF1.0 GMV（YTD）',
    wholesale2GmvAddYear: 'PF2.0 GMV（YTD）',

    gmvGraph: 'GMV Trend Graph (weekly)',
    top10BrandList: 'Vendor Top 10 Selling Brands',
    brandListState: '(these Brand\'s Ranking in IM)',
    brandName: 'Brand',
    gmvRank: 'Ranking',
    brandRank: 'These Brand`s Ranking in IM',

    goVendorHistory: 'Click to see more merchant data',
    curGmv: 'This Year GMV',
    preGmv: 'Last Year GMV',
    curOrders: 'This Year Orders',
    preOrders: 'Last Year Orders',
    submitStoreInfo: 'Submit store information',
    pleaseSelectReviewer: 'Please select a reviewer',
    selectReviewer: 'Select a reviewer',
    storeReviewer: 'Store reviewer',
    storeType: 'Store type',
    salesRegion: 'sales region',
    orderDeadLine: 'Order Deadline for a Day',
    orderConfirm: 'Order Confirmation Day from Merchant',
    shipDeadline: 'Shipping Deadline',
    shipDay: 'Order Shipping Day',
    orderNoticeLink: 'Order Status Notification Email Address',
    orderNoticeStatus: 'Order Notification Status',
    incorrectPostalCodeFormat: 'Incorrect postal code format',
    goodsInfo: 'Vendor Stock Info',
    totalStockValue: 'Total Stock Value (YSD)',
    dailyNewStock:' Daily New Stock Value & Ranking in IM',
    soltOutRank:'Sold-out Rate (Last Month) & Ranking in IM',
    newStockFre:'New Stock Frequency（per month)',
    stockStatus07: 'Stock Quality（YSD）',
    level: 'NO.{0}',
    former: 'former',
    conductor: 'conductor',
    changeRequest: 'change request',

    logisticsRelated: 'Logistics related',
    tmsLogisticsRoute: 'TMS shipping route',
    logisticsType: 'Logistic methods',
    expressConfig: 'Logistics company setting',
    logisticsSettlementMethod: 'Logistics payment frequency',
    fullFormLogisticsRelatedTip: 'Please complete the Logistics related',
    fullFormStockLocationTip: 'Please complete the StockLocation',
    transferWarehouseName: 'Transfer warehouse',
    fullFormPaymentTip: 'Please complete the Payment',
    parentBranchStore: 'Parent or branch store?',
    branchStore: 'Branch store',
    parentStore: 'Parent store',
    parentStoreName: 'Parent store',

    wholesaleV2Conf: 'Wholesale 2.0 config',
    wholesaleField1: 'Under list Vendor',
    wholesaleField2: 'Synchronized inventory  Vendor',

    tempStorage: 'Temp storage',
    allowCategoryMappingFail: 'Allow category mapping to fail',
    addPortalOperator: 'Add portal operator',
    portalOperator: 'Portal operator',
    afterSalesInfoManage: '履约售后信息维护',
    afterSaleAging: 'After sales effectiveness',
    returnTimeLimit: 'Time limit of return',
    whetherToAcceptAfterSales: 'Whether to accept after-sales service',
    notAcceptedAfterSalesType: 'After sales type of Not accepted',
    notAcceptedAfterSalesCases: 'After sales cases that do not accept defects',
    SevenDayNoReasonReturn: 'Seven-day no-reason return',
    ShowNoReasonAfterSaleImage: 'Show No Reason After Sale Image',
    show: 'Show',
    notShow: 'Not Show',
    notAcceptedAfterSalesCategories: 'Categories that do not accept after-sales service',
    portalVersion: 'portal type',
    orderOperationMode: 'Order operation mode',
    packingBoxMode: ' Packing mode',
    logisticsMode: 'Logistics transportation mode',
    stockErrorProblem: 'Inventory error prone problems',
    priceErrorProblem: ' Price mistakes',
    performanceBottleneck: 'Performance bottleneck',
    afterSaleSituation: '履约售后情况',
    workLog: '工作日志',
    techConfChanges: '技术配置更改',
    logChangeType: '更改类型',
    logChangeContent: '更改内容',
    logChangeTime: '更改时间',
    logVisitType: '拜访类型',
    logVisitDate: '拜访日期',
    logVisitPurpose: '拜访目的',
    logComeToAgreement: '达成协议',
    logRemark: '备注',
    logVisitPeopel: '拜访人',
    addVisitRecord: '添加拜访记录',
    visitRecord: '拜访日志',
    officialWebsite: 'Official website',
    destroyStore: 'Destroy store',
    confirmDestroyStore: 'The current store meets the destroy conditions, are you sure to destroy the store?',
    unclaimedBalanceStatus: 'Have an outstanding balance',
    unSettlementOrderStatus: 'Have open orders',
    unSettlementAmountStatus: 'Have an outstanding amount',
    storeCannotBeDestroyed: 'The current store cannot be destroyed',
    vendorSaleAfterAddressInfo: 'Merchant return information',
    receiveUserName: 'Contact Person',
    receivePhone: 'Contact Phone Number',
    receiveEmail: 'Contact Email',
    receivePostCode: 'Postal Code',
    receiveVatNum: 'VAT Number',
    receiveAddressCountry: 'Country',
    receiveAddressCity: 'City',
    receiveAddress: 'Address',
    addAddressInfo: 'Add return information',
    editAddressInfo: 'Edit return information',
    portalPriceAdjustment: 'System store portal price adjustment',
    supportAftersalesPriceReduction: 'Support after-sales price reduction',
    vendorStageRuleRow: '售后周期列数',
    daysOfAftersalePriceReductionCycle: 'Days of after-sale price reduction cycle',
    supportReserve: 'Support reservation',
    batchUpdateBD: 'Change Representative or Representative',
    batchUpdateBDTip: 'After saving, the representative or representative of the currently selected store will be changed',
    technicalContact: 'Technical contact',
    batchSelectVendor: 'Select a vendor in bulk',
    batchEnterVendorTip: 'Please enter the name of vendor (one per line, up to 1,000):',
    batchVendorNotExistTip: 'The following vendors do not exist:',
    batchVendorReverseTip: 'Checking this box means selecting all the vendors except the following vendors.',
    batchVendorLimitTip: 'The number of input lines is not allowed to exceed 1000, please re-enter',
    copyInvoiceFrom: 'Copy invoice information and payment information from',
    addFast: 'Quick Banned',
    deleteFast: 'Remove Quick Banned',
    batchSelectVendorId: 'Select a vendor id in bulk',
    batchEnterVendorIdTip: 'Please enter the id of vendor (one per line, up to 1,000):',
    batchVendorIdNotExistTip: 'The following vendor ids do not exist:',
    openSettlement: 'Enable Settlement',
    closeSettlement: 'Disable Settlement',
    confirmCloseSettlement: 'Confirm to disable settlement for this store?',
    confirmOpenSettlement: 'Confirm to enable settlement for this store?',
    openSettlementSuccess: 'Settlement enabled successfully',
    closeSettlementSuccess: 'Settlement disabled',
  },
}
